<template>
  <div class="wspo-form-control">
    <div
      class="wspo-form-label"
      v-show="value || error"
      :class="{ 'wspo-red': error }"
    >
      {{ error || label }}
    </div>
    <input
      class="wspo-form-input"
      @input="onInput"
      :value="value"
      :placeholder="label"
    />
    <div
      v-if="required && !value"
      class="wspo-form-input-requirator wspo-icon"
      :class="{ 'wspo-red': error }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    value: String,
    error: String,
    label: String,
    required: Boolean,
    onInput: Function
  }
};
</script>

<style scoped>
.wspo-form-input-requirator {
  position: absolute;
  right: 9px;
  top: 9px;
  padding: 16px 10px 14px;
  cursor: pointer;
  pointer-events: none;
  transition: 0.3s;
}
.wspo-form-input-requirator:before {
  content: '\f069';
  color: var(--color-text);
  font-size: 12px;
}
.wspo-red,
.wspo-red:before {
  color: var(--color-second);
}
.wspo-form-input::placeholder {
  color: var(--color-text);
  font-weight: 600;
  opacity: 0.75;
}
.wspo-form-input:focus::placeholder {
  color: var(--color-alt);
}
</style>
